<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Encaminhamento Médico"
    >
        <List
            v-if="isList"
            :data="data"
            @edit="handleEdit"
        />

        <Form
            v-else
            :data="data"
            :model="model"
            @saved="saved"
            ref="Form"
        />

        <template v-slot:footer="{ cancel }">
            <template v-if="isList">
                <rkm-button @click="cancel">
                    Fechar
                </rkm-button>

                <rkm-button
                    @click="print()"
                    :disabled="encaminhamentos.length === 0"
                >
                    Imprimir todos
                </rkm-button>

                <rkm-button
                    @click="handleCreate"
                    color="primary"
                >
                    Adicionar Encaminhamento
                </rkm-button>
            </template>

            <template v-else>
                <rkm-button @click="layout = 'list'">
                    Voltar
                </rkm-button>

                <rkm-button
                    @click="handleSave"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'
import List from './List'

// Mixins.
import { repository, error, stringCase } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { Form, List },
    created() {

        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.prontoAtendimento.atendimentoTriagem')
        }
    },
    data: () => ({
        layout: null,
        model: null,
    }),
    computed: {
        isList() {
            return this.layout == 'list'
        },
        isForm() {
            return this.layout == 'form'
        },
        encaminhamentos() {

            return this.data.form.encaminhamentos.concat(this.data.model.encaminhamentos)
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open() {
            this.layout = 'list'
            this.$refs.RkmModal.show()
        },
        print() {

            this.setLoading()

            const data = {
                pacienteId: this.data.form.paciente.id,
                encaminhamentos: this.encaminhamentos.map(item => isNaN(item.id)
                    ? {
                        infraestrutura_id: item.infraestruturaId,
                        motivo: item.motivo,
                    }
                    : { id: item.id }
                ),
            }

            this.repositories.impressao.guiaEncaminhamento(null, this.camelObjectKeysToSnakeRecursive(data))
                .then(response => {

                    const content = new Blob([response.data], { type: response.headers['content-type'] })
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()

                    URL.revokeObjectURL(url);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleCreate() {
            this.model = Object.assign({}, {
                id: null,
                lotacao: {
                    ocupacao: {
                        codigo: this.data.form.lotacao.ocupacao.codigo,
                    },
                    profissional: {
                        nome: this.data.form.lotacao.profissional.nome,
                    }
                },
                unidadeId: null,
                infraestruturaId: null,
                urgente: false,
                motivo: null,
                observacoes: null,
            })

            this.layout = 'form'
        },
        handleEdit(item) {
            this.model = Object.assign({}, {
                id: item.id,
                lotacao: {
                    ocupacao: {
                        codigo: item.lotacao.ocupacao.codigo,
                    },
                    profissional: {
                        nome: item.lotacao.profissional.nome,
                    }
                },
                unidadeId: item.unidadeId,
                infraestruturaId: item.infraestruturaId,
                urgente: item.urgente,
                motivo: item.motivo,
                observacoes: item.observacoes,
            })

            this.layout = 'form'
        },
        handleSave() {
            this.$refs.Form.save()
        },
        handleExit() {
            this.$refs.RkmModal.hide()
        },
        saved() {
            this.layout = 'list'
        },
    },
    mixins: [repository, error, stringCase],
    props: {
        data: { type: Object, required: true },
    },
}
</script>